import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE, DOWNLOAD_EXCEL } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// ChildCategory - Get All (Read)
export const GetAll = createAsyncThunk(
  "admin/instrument-management/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Consumable_item}?unique_id=${filter?.unique_id ||
          ""}&instrument_name_id=${filter?.instrument_name_id ||
          ""}&calibration_status_id=${filter?.calibration_status_id ||
          ""}&calibrated_id=${filter?.calibrated_id ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.perPage ||
          IDS.PERPAGE}&name=${filter?.name || ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date ||
          ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ChildCategory - Get (Read)
export const GetSingle = createAsyncThunk(
  "admin/instrument-management/get-single",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Consumable_item}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// ChildCategory - Create (Add)
export const Create = createAsyncThunk(
  "admin/instrument-management/create",
  async (sendData, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Consumable_item, sendData);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Update = createAsyncThunk(
  "admin/instrument-management/update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Consumable_item}/${id}`, sendData);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Delete = createAsyncThunk(
  "admin/instrument-management/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Consumable_item}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetInstrumentCounter = createAsyncThunk(
  "admin/sample-management/count",
  async (_, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Consumable_item}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "consumable_item",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    counter: {
      total: 0,
      scheduled: 0,
      in_progress: 0,
      verified: 0,
      pending_review: 0,
    },
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetInstrumentCounter.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetInstrumentCounter.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.counter = action.payload?.data || state.counter;
      })
      .addCase(GetInstrumentCounter.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (country) => country.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (country) => country.id !== action.payload.id,
        ); // Remove the country with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
